import React from 'react';
import PropTypes from 'prop-types';
import DataGrid from '../data-grid/'
import { Link, useHistory } from "react-router-dom";
import './album-grid.scss';

export const AlbumGrid = ({albums, hasMore, isLoading, length, onNext}) => {
	let history = useHistory();
	const AlbumTitleCell = ({value, row}) => {
		return <Link to={`/albums/${row.values.albumId}`} key={`album_title_${row.values.albumId}`} className={`grid-action grid-action-${row.values.albumId}`}>{value}</Link>
	}

	function handleRowClick (row) {
		history.push(`/albums/${row.values.albumId}`);
	}

	const columnData = [
		{
			Header: 'Album ID',
			accessor: 'id',
			id: 'albumId'
		},
		{
      Header: 'Artist',
      accessor: 'artist'
    },
		{
      Header: 'Album Title',
			Cell: AlbumTitleCell,
      accessor: 'albumName'
    },
    {
      Header: 'Genre',
      accessor: 'genres'
    },
    {
      Header: 'Label',
      accessor: 'labels'
    },
    {
      Header: 'Release Date',
      accessor: 'releaseDate'
    }
  ];

	return (
		<div className="album-grid">
			<div className="col-layout label-with-actions grid-header">
				<div className="grid-title"><h1>Albums</h1></div>
				<div className="actions grid-actions">
					<Link to="/add-album/" className="btn primary">Add New Album</Link>
				</div>
			</div>
			<div className="grid-body">
				<DataGrid
					data={albums || []}
					columnData={columnData}
					hasMore={hasMore}
					hiddenColumns={['albumId']}
					isLoading={isLoading}
					length={length}
					onNext={onNext}
					onRowClick={handleRowClick}
				/>
			</div>
		</div>
	);
}

AlbumGrid.propTypes = {
	albums: PropTypes.array,
	isLoading: PropTypes.bool
};

export default AlbumGrid;
